import { useEffect } from "react";
import { useLocation } from "react-router-dom";

let ReactGA = null;
import("react-ga4").then(mod => {
  ReactGA = mod.default;
  ReactGA.initialize("G-Z2M0VNF7F7");
}).catch(() => {});

const sendPageView = (page) => {
  if (ReactGA) {
    ReactGA.send({ hitType: "pageview", page });
  }
};

const Analytics = () => {
  const location = useLocation();

  useEffect(() => {
    const fullPath = window.location.pathname + window.location.search;
    sendPageView(fullPath);
  }, [location]);

  return null;
};

export default Analytics;
